import { CtaButton } from '@tkww/orion-web-ds-action';
import { TextBody, TextTitle } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

interface ExitConfirmationProps {
	cancelButtonRef: React.RefObject<HTMLButtonElement>;
	dialogRef: React.RefObject<HTMLDivElement>;
	onGoBack: () => void;
	onLeave: () => void;
}

export const ExitConfirmation = ({
	cancelButtonRef,
	dialogRef,
	onGoBack,
	onLeave,
}: ExitConfirmationProps) => (
	<div className={Styles.exitConfirmation} ref={dialogRef}>
		<div className={Styles.content}>
			<TextTitle size="xs">Leave without saving your new estimate?</TextTitle>
			<TextBody size="md" color="subtle-dark">
				Anything you've edited so far won't be saved.
			</TextBody>
		</div>
		<div className={Styles.footer}>
			<CtaButton
				className={Styles.ctaButton}
				styleType="secondary"
				size="md"
				ref={cancelButtonRef}
				onClick={onGoBack}
			>
				Go back
			</CtaButton>
			<CtaButton
				className={Styles.ctaButton}
				styleType="primary"
				size="md"
				onClick={onLeave}
			>
				Leave anyway
			</CtaButton>
		</div>
	</div>
);
